import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const event = new CustomEvent('modalLoaded', {bubbles: true, cancelable: true});
    this.element.dispatchEvent(event)
  }
}
